export default __webpack_public_path__ + "static/media/köide_001.2fa11136.jpg";